// Generated by genversion.
module.exports = '2.0.6'
